import {isTruthy, performRequest} from 'shared/utils';

import {IDescriptiveFlexfieldSegment} from './descriptive-flexfields-slice-types';

const DFFEndpoint = 'dff';

export interface IFetchDFFColumnsRequestParams {
    contextCode: string;
    dffName: string;
}

export interface IFetchDFFColumnsArgs {
    params: IFetchDFFColumnsRequestParams;
    prefix?: string;
}

export type TFetchDDContextDFFColumnsRequestParams = Omit<IFetchDFFColumnsRequestParams, 'dffName'>;

export const fetchDFFColumns = (
    {prefix, params}: IFetchDFFColumnsArgs,
) => performRequest<IDescriptiveFlexfieldSegment[]>({
    url: [prefix, DFFEndpoint, 'columns'].filter(isTruthy).join('/'),
    method: 'GET',
    params,
});
